
import { AppRoute } from './types'
import { AddCompanyPage, ServerDatabasesPage } from './pages'
import { ADD_COMPANY_ROUTES } from './routes-typed'

export const addCompanyRoutesMap = {
  addCompany: ADD_COMPANY_ROUTES.addCompany.path,
  serverDatabases: ADD_COMPANY_ROUTES.serverDatabases.path,
}

export const addCompanyRoutes: AppRoute[] = [
  {
    path: addCompanyRoutesMap.addCompany,
    component: AddCompanyPage,
    exact: true,
  },
  {
    path: addCompanyRoutesMap.serverDatabases,
    component: ServerDatabasesPage,
  },
]
